module.exports = __webpack_public_path__ + "img/teacher-introduction.25d9859a.png";